import { lazy } from 'react'

const Dashboard = lazy(() => import('@/pages/dashboard/dashboard'))
const EditProfile = lazy(
  () => import('@/pages/dashboard/edit-profile/edit-profile'),
)
const RegisterUser = lazy(
  () => import('@/pages/dashboard/register-user/register-user'),
)

const ViewProperty = lazy(() => import('@/pages/view-property/view-property'))

const CommissionsList = lazy(
  () => import('@/components/agent/commissions-list'),
)

const InstallmentsList = lazy(
  () => import('@/pages/dashboard/agent/installments-list'),
)

const ViewContract = lazy(
  () => import('@/components/property/finances-tab/view-contract'),
)

const AddAndEditProperty = lazy(
  () => import('@/pages/property/add-property/add-and-edit-property'),
)

const AddAndEditPerimeterCoordinates = lazy(
  () =>
    import('@/pages/property/add-property/coordinates/addAndEdit-perimeter'),
)

const PreservationContract = lazy(
  () => import('@/pages/property/add-property/contract'),
)

const ResetPassword = lazy(
  () => import('@/pages/reset-password/reset-password'),
)

const ListPreservers = lazy(
  () => import('@/pages/backoffice/conservatives/conservatives'),
)

const NotFound = lazy(() => import('@/pages/not-found'))

const Ping = lazy(() => import('@/pages/ping'))

const Iconography = lazy(() => import('@/pages/iconography'))

const DesignSystem = lazy(() => import('@/pages/design-system/design-system'))

const ContactSponsorship = lazy(
  () => import('@/pages/contact-sponsorship/contact-sponsorship'),
)

const MessageSponsorship = lazy(
  () => import('@/pages/contact-message-sponsorship'),
)

const ConfirmSponsor = lazy(() => import('@/pages/confirm-sponsor'))

const ProcessSimulation = lazy(
  () => import('@/pages/backoffice/simulation/process-simulation'),
)

const ListSponsors = lazy(() => import('@/pages/backoffice/sponsors'))

const ListUsersTypes = lazy(
  () => import('@/pages/backoffice/users-types/users-types'),
)

const ListProperties = lazy(
  () => import('@/pages/backoffice/properties/properties'),
)

const ListSponsorships = lazy(
  () => import('@/pages/backoffice/sponsorships/sponsorships'),
)
const ListDocuments = lazy(
  () => import('@/pages/backoffice/sponsorships/documents'),
)
const ListUsers = lazy(() => import('@/pages/backoffice/admin-users/users'))
const ListPublications = lazy(
  () => import('@/pages/backoffice/publications/publications'),
)
const ListSignatories = lazy(
  () => import('@/pages/backoffice/signatories/signatories'),
)

const ListScores = lazy(() => import('@/pages/backoffice/scores/list-scores'))

const ListGuardians = lazy(
  () => import('@/pages/backoffice/guardians/guardians'),
)
const ListTeam = lazy(() => import('@/pages/backoffice/team/team'))
const ListTestimonials = lazy(
  () => import('@/pages/backoffice/testimonials/testimonials'),
)
const ListBanners = lazy(() => import('@/pages/backoffice/banners/banners'))

const ListAgents = lazy(() => import('@/pages/backoffice/agents/agents'))

const ListSupervisors = lazy(
  () => import('@/pages/backoffice/supervisors/supervisors'),
)

const CreateAndEditBanner = lazy(
  () => import('@/pages/backoffice/banners/create-and-edit-banner'),
)
const CreateAndEditPublication = lazy(
  () => import('@/pages/backoffice/publications/create-and-publication'),
)

const ListLogs = lazy(() => import('@/pages/backoffice/logsList/logs'))
const WebsiteConfig = lazy(
  () => import('@/pages/backoffice/website-config/config'),
)

const ListLgpdUsers = lazy(() => import('@/pages/backoffice/lgpd/lgpd'))
const AddAndEditCertificate = lazy(
  () => import('@/pages/backoffice/properties/certificate'),
)
const IntegrationWorkerAndBlockchain = lazy(
  () =>
    import(
      '@/pages/backoffice/workerAndblockchain/integration-worker-blockchain'
    ),
)

const ContactMessage = lazy(() => import('@/pages/contact-message'))

const Property = lazy(() => import('@/pages/property/property'))
const AddAndEditSponsorship = lazy(
  () =>
    import(
      '@/pages/backoffice/sponsorships/addAndEdit-Sponsorship/sponsorship'
    ),
)
const ViewPreviewContract = lazy(
  () =>
    import(
      '@/pages/backoffice/sponsorships/addAndEdit-Sponsorship/view-preview-contract'
    ),
)

const FinancialDataSponsorship = lazy(
  () => import('@/pages/backoffice/sponsorships/financial-data-sponsorship'),
)

const BankDetails = lazy(() => import('@/pages/bank-details/bank-details'))

const CreatingAgentByAdmin = lazy(
  () => import('@/pages/backoffice/agent/create-form/creating-agent-by-admin'),
)

const CreateAndEditAgentIndications = lazy(
  () =>
    import(
      '@/pages/backoffice/agent/indications/create-and-edit-agent-indications'
    ),
)

const CreateAgentContractById = lazy(
  () => import('@/pages/backoffice/agent/contract/create-agent-contract-by-id'),
)

const AgentContractPreview = lazy(
  () => import('@/pages/backoffice/agent/contract/agent-contract-preview'),
)

const ListSignatoriesAssociation = lazy(
  () =>
    import(
      '@/pages/backoffice/signatories-association/signatories-association'
    ),
)

const ListSignatoryRoles = lazy(
  () => import('@/pages/backoffice/signatory-roles/signatory-roles'),
)

const LGPDContacts = lazy(() => import('@/pages/LGPD-contacts/LGPD-contacts'))

const Preservation = lazy(() => import('@/pages/preservation/preservation'))
const Damping = lazy(() => import('@/pages/damping/damping'))
const Monitoring = lazy(() => import('@/pages/monitoring/monitoring'))
const Regeneration = lazy(() => import('@/pages/regeneration/regeneration'))
const Carbon = lazy(() => import('@/pages/carbon/carbon'))

const PublicationDetail = lazy(
  () => import('@/pages/publications/publication-detail'),
)

const RegisterAgent = lazy(() => import('@/pages/register/agent'))

const CreateCompletePreserver = lazy(
  () =>
    import(
      '@/pages/register/create-complete-preserver/create-complete-preserver'
    ),
)

const CreateCompleteSupervisor = lazy(
  () =>
    import(
      '@/pages/supervisor/create-complete-supervisor/create-complete-supervisor'
    ),
)

const NotAllowed = lazy(() => import('@/pages/not-allowed'))

const ListPayments = lazy(
  () => import('@/pages/backoffice/payments/list-payments'),
)

const CheckScore = lazy(
  () => import('@/pages/backoffice/check-score/check-score'),
)

const ViewAgentContract = lazy(
  () => import('@/pages/agent/contract/view-agent-contract'),
)

export {
  AddAndEditCertificate,
  AddAndEditPerimeterCoordinates,
  AddAndEditProperty,
  ConfirmSponsor,
  ContactMessage,
  ContactSponsorship,
  CreateAndEditBanner,
  CreateAndEditPublication,
  ListLgpdUsers,
  Dashboard,
  DesignSystem,
  EditProfile,
  Iconography,
  IntegrationWorkerAndBlockchain,
  ListBanners,
  ListGuardians,
  ListLogs,
  ListPreservers,
  ListProperties,
  ListPublications,
  ListSignatories,
  ListSponsors,
  ListSponsorships,
  ListDocuments,
  ListTeam,
  ListTestimonials,
  ListUsers,
  InstallmentsList,
  MessageSponsorship,
  NotFound,
  PreservationContract,
  ListScores,
  ProcessSimulation,
  WebsiteConfig,
  Property,
  RegisterUser,
  ResetPassword,
  Ping,
  ViewContract,
  ViewProperty,
  AddAndEditSponsorship,
  ViewPreviewContract,
  FinancialDataSponsorship,
  BankDetails,
  CreatingAgentByAdmin,
  CreateAndEditAgentIndications,
  ListAgents,
  ListSupervisors,
  ListUsersTypes,
  CreateAgentContractById,
  AgentContractPreview,
  CommissionsList,
  ListSignatoriesAssociation,
  ListSignatoryRoles,
  LGPDContacts,
  Preservation,
  Damping,
  Monitoring,
  Regeneration,
  Carbon,
  PublicationDetail,
  RegisterAgent,
  CreateCompletePreserver,
  CreateCompleteSupervisor,
  NotAllowed,
  ListPayments,
  CheckScore,
  ViewAgentContract,
}
